import { render, staticRenderFns } from "./ProductDetailBadges.vue?vue&type=template&id=e1809c60&scoped=true&"
import script from "./ProductDetailBadges.vue?vue&type=script&lang=ts&"
export * from "./ProductDetailBadges.vue?vue&type=script&lang=ts&"
import style0 from "./ProductDetailBadges.vue?vue&type=style&index=0&id=e1809c60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1809c60",
  null
  
)

export default component.exports